<template>
  <v-card>
    <v-card-title>
      อาคาร 
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="ค้นหา"
        single-line
        hide-details
        class="mr-3"
      ></v-text-field>
      <v-tooltip left>
        <v-btn color="teal" slot="activator" dark fab @click="addItem()">
          <v-icon>playlist_add</v-icon>
        </v-btn>
        <span>เพิ่มอาคาร</span>
      </v-tooltip>

      <v-dialog v-model="dialog" max-width="80%">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-text-field v-model="editedItem.name" label="ชื่ออาคาร"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn dark color="grey" @click="close">ยกเลิก</v-btn>
            <v-spacer></v-spacer>
            <v-btn dark color="green" @click="save">บันทึก</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-title>
    <v-data-table
    	:loading="loading"
      :headers="headers"
      :items="items"
      :search="search"
      :pagination.sync="pagination"
      hide-actions
    >
      <template slot="items" slot-scope="props">
      	<td>{{ props.item.name }}</td>
				<td class="text-xs-right">
					<v-tooltip left>
	          <v-icon
	          	slot="activator"        
	            color="blue"
	            class="mr-2"
	            @click="editItem(props.item)"
	          >
	            edit
	          </v-icon>
	          <span>แก้ไข</span>
      		</v-tooltip>
          <v-tooltip left>
	          <v-icon
	          	slot="activator"
	            color="red"
	            @click="deleteItem(props.item)"
	          >
	            delete
	          </v-icon>
	          <span>ลบ</span>
      		</v-tooltip>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import swal from 'sweetalert2'

export default {
  data () {
  	return {
  		dialog: false,
  		search: '',
  		headers: [
        { text: 'อาคาร', align: 'left', sortable: true, value: 'name' },
        { text: '', sortable: false }
      ],
      editedIndex: -1,
      editedItem: { name: '' },
      defaultItem: { name: '' },
      pagination: {
        q: '',
        sortBy: 'name',
        descending: true,
        page: 1,
        rowsPerPage: 25,
        totalItems: 0
      }
  	}
  },
  computed: {
  	...mapGetters({
      loading: 'building/loadingStatus',
      items: 'building/buildingItems'
    }),
    formTitle () {
      return this.editedIndex === -1 ? 'เพิ่มอาคาร' : 'แก้ไขอาคาร'
    }
  },
  created () {
    this.initialize()
  },
  mounted () {

  },
  methods: {
  	...mapActions({
      initialize: 'building/loadBuildingItems'
    }),
  	addItem () {
  		this.dialog = true
  	},
  	editItem (item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      const index = this.items.indexOf(item)
      swal({
        title: 'คุณแน่ใจ?',
        text: "คุณจะไม่สามารถเรียกคืนข้อมูลได้อีก!",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่, ฉันต้องการลบข้อมูลนี้!'
      }).then((result) => {
        console.log('swal', result.value)
        if (result.value) {
          const dispatch = 'building/deleteBuilding'
		      this.$store.dispatch(dispatch, item)
		        .then((response) => {
		          setTimeout( ()=>this.initialize (), 500)
		          this.close()
		        }).catch((error)=>{
		          console.log('initialize', error)
              swal('เกิดข้อผิดพลาด!', error.message, 'error')
		        })
          swal(
            'ลบรายการ!',
            'คุณได้ทำการลบรายการเรียบร้อยแล้ว',
            'success'
          )
        }
      })
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
    	const dispatch =  this.editedIndex === -1 ? 'building/createBuilding' : 'building/updateBuilding'
      this.$store.dispatch(dispatch, this.editedItem)
        .then((response) => {
          setTimeout( ()=>this.initialize (), 500)
          this.close()
        }).catch((error)=>{
          console.log('initialize', error)
        })
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  } 
}
</script>



// WEBPACK FOOTER //
// src/components/settings/building/dataTables/building.vue